import PropTypes from 'prop-types';
import { Link } from 'react-router-dom'

// material-ui
import { Typography, Grid, Breadcrumbs } from '@mui/material'

export const PageHeader = ({ title, breadcrumbs = [] }) => {
    return (
        <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={1} sx={{ mb: 2 }}>
            <Grid item sx={{ mt: 0 }} style={{ flexGrow: 1 }}>
                <Typography variant="h4">{title}</Typography>
            </Grid>
            <Grid item>
                <Breadcrumbs aria-label="breadcrumb">
                    <Typography component={Link} to="/" color="textSecondary" variant="h6" sx={{ textDecoration: 'none' }}>Home</Typography>
                    {breadcrumbs.map((item, i) => <Typography key={i} component={Link} to={item.path ?? '#'} color="textSecondary" variant="h6" sx={{ textDecoration: 'none' }}>{item.label}</Typography>)}
                </Breadcrumbs>
            </Grid>
        </Grid>
    )
}

PageHeader.propTypes = {
    title: PropTypes.string,
    breadcrumbs: PropTypes.any,
};
